import CustomButton from "@/components/desktop/button/CustomButton";
import classes from "../filter.module.scss";

const FilterApplyButton = ({ onClick }) => {
	return (
		<div className={classes.applyButtonWrapper}>
			<CustomButton variant="outline" size="md" block onClick={onClick}>
				Aplicar
			</CustomButton>
		</div>
	);
};

export default FilterApplyButton;
